export default __webpack_public_path__ + "static/media/pd3.1b33a1b7.jpg";